<template>
  <div class="wrapper signup-page-wrp">
    <div class="signup-page signin-page">
      <div class="signup-page-right">
        <div class="align" style="width: 50%; margin: 0 auto;">
          <!--                      <clip-loader :loading="loading" :size="size" :color="spinnerColor"></clip-loader>-->
          <img src="/public/images/loader.gif" alt="">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'login',
  data() {
    return {
      form: {
        token: this.$route.query.token,
        email: this.$route.query.email,
        password: this.$route.query.tokenpass,
        authentication: this.$route.query.authentication,
        type: 'MANAGER',
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        supportLogin: '1',
        fcm_token: 'web',
      },
    }
  },
  created() {
    this.login();
  },
  methods: {
    login() {
      localStorage.setItem('isLogin', 0);
      this.$store.commit("logoutUser");
      this.$store.commit('setUser', '');
      if (this.form.token) {
        this.$axios
          .post(this.$SupportLogin, $.param(this.form))
          .then(response => {
            if (response.data.status === 200) {
              let user = response.data.result.user;
              this.$store.commit('setUser', user);
              this.$store.commit('setLoginInProfile', user );
              localStorage.setItem('isLogin', 1);
              localStorage.setItem('companyEmployees', JSON.stringify(null));
              //this.$router.go(0);
            }
          })
          .catch(error => {
            console.log(error);
          })
      }
    },
  }
}
</script>


